import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../../Button';
import { isSpeechRecognitionSupported } from '../../../../lib/shared/speech-recognition';
import styles from './MemoryChatButtons.css';

const cx = classnames.bind(styles);

const isVoiceInputSupported = isSpeechRecognitionSupported();

function MemoryChatButtons({ isListening, hasText, onVoiceInputClick }) {
    const isVoiceInputVisible = isVoiceInputSupported && (isListening || !hasText);

    return isVoiceInputVisible ? (
        <Button
            key='voiceInput'
            type='primary'
            rounded
            iconLeft={{ name: isListening ? 'stop' : 'microphone' }}
            className={cx('button', { listening: isListening })}
            onClick={onVoiceInputClick}
            buttonProps={{
                type: 'button',
                'aria-label': isListening ? 'Stop voice input' : 'Start voice input',
                'aria-pressed': isListening
            }}
        />
    ) : (
        <Button
            key='send'
            type='primary'
            rounded
            iconLeft={{ name: 'send' }}
            disabled={!hasText}
            className={styles.button}
            buttonProps={{ type: 'submit', 'aria-label': 'Send' }}
        />
    );
}

MemoryChatButtons.propTypes = {
    isListening: PropTypes.bool.isRequired,
    hasText: PropTypes.bool.isRequired,
    onVoiceInputClick: PropTypes.func.isRequired
};

export {
    MemoryChatButtons
};
